export default __webpack_public_path__ + "static/media/maispontos-banner-large.cb9e66fc.png";